import { render, staticRenderFns } from "./SectionCountItem.vue?vue&type=template&id=8607fe76&scoped=true"
import script from "./SectionCountItem.vue?vue&type=script&lang=js"
export * from "./SectionCountItem.vue?vue&type=script&lang=js"
import style0 from "./SectionCountItem.vue?vue&type=style&index=0&id=8607fe76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8607fe76",
  null
  
)

export default component.exports